<template>

  <div class="hello">
    <div class="holder">
      <form @submit.prevent="addSkill">
        <input type="text" placeholder="New to-do..." v-model="skill" v-validate="'min:5'" name="event">
        <transition name="alert-in" enter-active-class="animated flipInX" leave-active-class="animated flipOutX">
          <p class="alert" v-if="errors.has('event')">{{ errors.first('event') }}</p>
        </transition>
      </form>
      <ul>
        <transition-group name="list" enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
          <li v-for="(data, index) in skills" :key='index'>
            {{ data.skill }}
            <div style="text-align: right;">
            <span>{{ data.date }}</span>
            </div>
            <i class="fa fa-minus-circle" v-on:click="remove(index)"></i>
          </li>
        </transition-group>
      </ul>
      <p>These are the things you still need to do.</p>
    </div>
    <p id="clock" class="text-white">
      {{date}}
          </p>
       <p id="date" class="text-white">
      {{time}}
            </p>
<div class="weather-wrapper">
    <div class="weather-card madrid">
        <div class="weather-icon sun"></div>
        <h2>26º</h2>
        <h3>Rotterdam</h3>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Skills',
  data() {
    return {
      skill: '',
      skills: [
        { "skill": "Clean up your room", date : new Date().toLocaleString()},
        { "skill": "Take out the trash", date : new Date().toLocaleString()}
      ],
      time : '',
      date : ''
    }
  },
  mounted : function () {
    const self = this
    setInterval( function() {
      let current_date = new Date()
      self.time =  `${self.zeroPadding(current_date.getHours(), 2)} : ${self.zeroPadding(current_date.getMinutes(), 2)} : ${self.zeroPadding(current_date.getSeconds(), 2)}`
      self.date = `${self.zeroPadding(current_date.getDate(), 2)} - ${self.zeroPadding(current_date.getMonth()+1, 2)} - ${self.zeroPadding(current_date.getFullYear(), 4)}`
    }, 1000)
  },
  methods: {
    addSkill() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.skills.push({skill: this.skill, date : new Date().toLocaleString()})
          this.skill = '';
        } else {
          console.log('Not valid');
        }
      })
    },
    remove(id) {
      this.skills.splice(id,1);
    },
    zeroPadding(num, digit) {
        var zero = '';
        for(var i = 0; i < digit; i++) {
            zero += '0';
        }
        return (zero + num).slice(-digit);
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import "https://fonts.googleapis.com/css?family=Anton";
  @import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";
  @import "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"; 
    @import "https://fonts.googleapis.com/css?family=Lato:100,300,400,700,900)";


*, *:before, *:after {
  box-sizing: border-box;
}

.weather-wrapper {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
}

.weather-card {
    
    margin:  0px 5px;
    border-radius: 20px;
    position: relative;
    overflow: hidden;
    width: 270px;
    height: 270px;
    background-color: #e8e8e8;}

    
    h3 {
        position: absolute;
        font-family: 'Lato', sans-serif;
        font-weight:100;
        font-size:28px;
        color: #aeaeae;
        bottom: 0;
        left: 35px;
        animation: title-appear 1s ease-out 500ms forwards;
    }
       h2 {
        position: absolute;
        font-family: 'Lato', sans-serif;
        font-weight:2 00;
        font-size:80px;
        color: #a4a4aa;
        bottom: 35px;
        left: -115px;
        opacity: 200;
        transform: translateX(150px);
        animation: title-appear 500ms ease-out 500ms forwards;
    }


.weather-icon {
  margin-top: 0%;
    position: relative;
    width: 65px;
    height: 65px;
    top: 0;
    float: right;
    margin: 40px 40px 0 0;
    animation: weather-icon-move 5s ease-in-out infinite;
}

.sun { 
    background: #e4ee22; 
	border-radius: 50%; 
	box-shadow: rgba(255,255,0,0.1) 0 0 0 4px;
    animation: light 800ms ease-in-out infinite alternate, weather-icon-move 5s ease-in-out infinite;
}

  #clock {
    font-family: 'Anton', sans-serif!important; 
    color: #ffffff;
    font-size: 3em;
    text-align: center;
    color: #daf6ff;
    text-shadow: 0 0 20px rgb(63, 41, 41),  0 0 20px rgba(10, 175, 230, 0);
    padding-bottom: 0px;
  
  }

  #date{
    font-family: 'Anton', sans-serif!important; 
    color: #ffffff;
    font-size: 6em;
    text-align: center;
    color: #daf6ff;
    text-shadow: 0 0 20px rgb(63, 41, 41),  0 0 20px rgba(10, 175, 230, 0);
      padding-top: 0px;
  }

  .holder {
    background: #fff;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
  
  ul li {
    padding: 20px;
    font-size: 1.3em;
    background-color: #E0EDF4;
    border-left: 5px solid #3EB3F6;
    margin-bottom: 2px;
    color: #3E5252;
  }

  p {
    text-align:center;
    padding: 10px 0;
    color: gray;
  }

  .container {
    box-shadow: 0px 0px 40px lightgray;
  }
 
  input {
    width: 100%;
    border: 0;
    padding: 20px;
    font-size: 1.3em;
    background-color: #323333;
    color: #687F7F;
  }
  .alert {
    background: #fdf2ce;
    font-weight: bold;
    display: inline-block;
    padding: 5px;
    margin-top: -20px;
  }

  .alert-in-enter-active {
    animation: bounce-in .5s;
  }
  .alert-in-leave-active {
    animation: bounce-in .5s reverse;
  }

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}

i {
  float:right;
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Skills.vue